import React from 'react'
import TableComponent from './table'
import './table-block.scss'

const TableBlock = () => {

  return (
    <div id="trade_view" className='table-block'>
        <div className="table-block__wrapper container">
            <h3 data-aos="fade-up" className="table-block__title title">Experience superior execution & investing conditions</h3>

            <TableComponent />
        </div>

    </div>
  )
}

export default TableBlock
